import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import styled from "styled-components";
import Button from "sushiweb/Button";
import { useLocation } from "react-router-dom";

const InputBar = (props) => {
  const stateObj = {
    email: undefined,
  };

  const location = useLocation();
  const [inputText, setInputText] = useState({ ...stateObj });

  const { handleSubmit } = props;

  const onChange = (val, key) => {
    const state = { ...stateObj };

    setInputText({
      ...state,
      [key]: val,
    });
  };

  const onSubmit = (evt) => {
    evt.preventDefault();
    handleSubmit(inputText);
  };

  useEffect(() => {
    const state = { ...stateObj };

    let stateChangeFlag = false;
    const searchQueryParams = location.search;
    const paramsObject = new URLSearchParams(searchQueryParams);
    if (paramsObject.has("email")) {
      state["email"] = paramsObject.get("email");
      stateChangeFlag = true;
    }

    if (stateChangeFlag) {
      setInputText(state);
      handleSubmit(state);
    }
  }, []);

  return (
    <InputBarFormContainer className="actionBar flex items-start" style={{justifyContent: "center"}}>
      <Input
        className="mr-10"
        fullWidth={false}
        style={{ width: "400px" }}
        value={inputText.email}
        autoFocus={true}
        label="Email"
        data-testid="email"
        onChange={(val) => onChange(val, "email")}
        id="sushi-input"
      />
      <Button
        className="sushi-btn"
        appearance="outline"
        btnColor="coal"
        data-testid="tripStatisticsSubmitBtn"
        onClick={onSubmit}
      >
        Search
      </Button>
    </InputBarFormContainer>
  );
};

const InputBarFormContainer = styled.div``;

export default InputBar;